<div class="body-container mx-auto">
  <form class="reg-form" [formGroup]="form" (ngSubmit)="onRegister()">
    <header>
      <h1 class="page-title text-center mt-3 mb-2">Registration</h1>
    </header>
    <div class="lato text-center">
      Welcome to Camp Bow Wow<sup>&#174;</sup>! Please fill out your info to
      continue.
    </div>
    <div class="reg-form-content mt-4">
      <div class="input-container">
        <span class="input-label">Email Address</span>
        <input
          title="email"
          type="text"
          class="input"
          formControlName="email"
        />
        <span class="error" *ngIf="f.email.touched && f.email.value === ''"
          >Please enter email address.</span
        >
        <span class="input-label italic">If you're a current customer, please enter the email address on file at Camp
          to merge your existing information upon account creation.
      </span>
        <span
          class="error"
          *ngIf="
            f.email.touched &&
            f.email.status === 'INVALID' &&
            f.email.value !== ''
          "
          >Please check email address. E.g. woof@example.com</span
        >
      </div>

      <app-password-form formControlName="passwordForm"></app-password-form>
      <hr />

      <div class="row no-gutters">
        <div class="col" style="padding-right: 0.625rem">
          <div class="input-container">
            <span class="input-label">First Name</span>
            <input
              title="firstName"
              type="text"
              class="input"
              formControlName="firstName"
            />
            <span
              class="error"
              *ngIf="f.firstName.touched && f.firstName.value === ''"
              >Please enter first name.</span
            >
          </div>
        </div>
        <div class="col" style="padding-left: 0.625rem">
          <div class="input-container">
            <span class="input-label">Last Name</span>
            <input
              title="lastName"
              type="text"
              class="input"
              formControlName="lastName"
            />
            <span
              class="error"
              *ngIf="f.lastName.touched && f.lastName.value === ''"
              >Please enter last name.</span
            >
          </div>
        </div>
      </div>

      <div formGroupName="phone" class="row no-gutters">
        <div class="col-7 input-container" style="padding-right: 0.625rem">
          <span class="input-label">Phone Number</span>
          <div class="d-flex bd-highlight">
            <select
              title="+1"
              class="input"
              style="width: auto"
              disabled="true"
            >
              <option selected="selected" value="+1">+1</option>
            </select>
            <input
              title="phoneNumber"
              type="text"
              class="input"
              formControlName="phoneNumber"
              mask="(000) 000-0000"
            />
          </div>
          <span
            *ngIf="
              f.phone.get('phoneNumber').touched &&
              f.phone.get('phoneNumber').value === ''
            "
            class="error"
            >Please enter phone number.</span
          >
          <span
            *ngIf="
              f.phone.get('phoneNumber').touched &&
              f.phone.get('phoneNumber').hasError('pattern') &&
              f.phone.get('phoneNumber').value !== ''
            "
            class="error"
            >Please check phone number.</span
          >
        </div>

        <div
          class="dropdown col-5 input-container"
          style="padding-left: 0.625rem"
        >
          <span class="input-label">Type</span>
          <mat-form-field class="input">
            <mat-select formControlName="phoneType">
              <mat-option
                *ngFor="let phoneType of myProfileService.phoneTypeList"
                [value]="phoneType"
                >{{ phoneType.type }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="action-container">
        <button
          type="submit"
          class="btn btn-danger btn-block"
          [disabled]="form.invalid"
        >
          Register Now
        </button>
      </div>
      <div class="text-right mt-3">
        <span class="lato black" style="font-size: 0.75rem"
          >Already have an account?
        </span>
        <a
          class="link"
          routerLink="/sign-in"
          tabindex="0"
          (click)="navigateToSignIn()"
          >Sign In</a
        >
      </div>
      <div class="text-right mb-3 lato tos-text">
        <span
          >By proceeding, you agree to our
          <a
            class="link"
            href="https://www.campbowwow.com/terms-of-use/"
            target="_blank"
            >Terms of Use</a
          >
          and
          <a
            class="link"
            href="https://www.campbowwow.com/privacy-policy/"
            target="_blank"
            >Privacy Policy</a
          >
        </span>
      </div>
    </div>
  </form>
</div>
